import { jsx as u, jsxs as n } from "react/jsx-runtime";
import { Modal as h } from "../components/Modal.js";
import { InfoIcon as f } from "../../../assets/svgs/InfoIcon.js";
const m = ({
  dataItem: l,
  setActiveRule: d,
  setView: i,
  isIO: r,
  closeIOModal: s,
  genericTaggingEvent: o
}) => {
  const c = () => {
    d(!1), i("coupons-view");
  };
  return /* @__PURE__ */ u(
    h,
    {
      isIO: r,
      closeModal: r && s ? s : c,
      genericTaggingEvent: o,
      title: "Regra de Utilização",
      confirmButtonAction: () => {
        o == null || o("discount_coupon", {
          name: "Modal regra de utilização - botão Ok, entendi"
        }), c();
      },
      confirmButtonText: "Ok, Entendi",
      cancelButtonAction: () => {
        o == null || o("discount_coupon", {
          name: "Modal regra de utilização - botão sair"
        }), c();
      },
      cancelButtonText: "Voltar para Meus Cupons",
      children: /* @__PURE__ */ n("p", { children: [
        /* @__PURE__ */ u("span", { children: /* @__PURE__ */ u(f, {}) }),
        /* @__PURE__ */ n("ul", { children: [
          l == null ? void 0 : l.couponRules.map((p) => /* @__PURE__ */ u("li", { children: p }, p)),
          /* @__PURE__ */ n("li", { children: [
            "Válido até ",
            l == null ? void 0 : l.couponExpirationDate
          ] })
        ] })
      ] })
    }
  );
};
export {
  m as RulesView
};
